import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencil: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPencil"><Path d="M16.5 1.58582L22.4142 7.50003L19.4142 10.5L13.5 4.58582L16.5 1.58582Z" fill="currentColor"/><Path d="M12.0858 6L2 16.0858V22H7.91421L18 11.9142L12.0858 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencil;
